import { httpClient } from "@bw/shared/api";
import type { Schema } from "@bw/shared/types/generated";

export type CampaignCreate = Schema["FacilityCampaignCreate"];
export type CampaignResponse = Schema["FacilityCampaignResponse"];
export type CampaignAuthoringContext =
  Schema["FacilityCampaignAuthoringContext"];
export type CampaignServiceAuthoringContext =
  Schema["FacilityCampaignServiceAuthoringContext"];
export type CampaignStatusUpdate = Schema["FacilityCampaignStatusUpdate"];

export function campaignServiceContext(
  context: CampaignAuthoringContext,
  service: CampaignCreate["service"],
): CampaignServiceAuthoringContext | undefined {
  return context.services.find((item) => item.service === service);
}

export function getCampaignAuthoringContext(
  facilityId: string,
): Promise<CampaignAuthoringContext> {
  return httpClient.get<CampaignAuthoringContext>(
    `/facilities/${facilityId}/campaigns/authoring-context`,
  );
}

export function getCampaigns(facilityId: string): Promise<CampaignResponse[]> {
  return httpClient.get<CampaignResponse[]>(
    `/facilities/${facilityId}/campaigns`,
  );
}

export function createCampaign(
  facilityId: string,
  body: CampaignCreate,
): Promise<CampaignResponse> {
  return httpClient.post<CampaignResponse>(
    `/facilities/${facilityId}/campaigns`,
    body,
  );
}

export function updateCampaignStatus(
  facilityId: string,
  campaignId: string,
  body: CampaignStatusUpdate,
): Promise<CampaignResponse> {
  return httpClient.patch<CampaignResponse>(
    `/facilities/${facilityId}/campaigns/${campaignId}/status`,
    body,
  );
}
